/* NEOKULT Shop-Stil Scripts */
(function(){
  'use strict';
  function $(s,r){return (r||document).querySelector(s);}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  function money(p){var c=(window.NEOKULT&&window.NEOKULT.currency)||'CHF';return c+' '+Number(p).toFixed(2);}

  function init(){
    /* Warenkorb-Zahl ausblenden bei 0 */
    $$('[data-cart-count]').forEach(function(b){
      function t(){var v=b.textContent.trim();b.hidden=(v==='0'||v==='');}
      t();
      new MutationObserver(t).observe(b,{childList:true,characterData:true,subtree:true});
    });

    /* Produkt-Slider Pfeile */
    $$('[data-nkz-slider]').forEach(function(s){
      var tr=$('.nkz-track',s);
      $$('[data-dir]',s).forEach(function(b){
        b.addEventListener('click',function(){
          var dir=b.getAttribute('data-dir')==='next'?1:-1;
          tr.scrollBy({left:dir*tr.clientWidth*0.8,behavior:'smooth'});
        });
      });
    });

    /* Filter: sofort anwenden */
    $$('[data-nkz-filters]').forEach(function(f){
      function go(){
        $$('input[type=number]',f).forEach(function(i){if(!i.value){i.disabled=true;}});
        f.submit();
      }
      f.addEventListener('change',function(e){
        if(e.target.type==='checkbox'||e.target.tagName==='SELECT'){go();}
      });
      f.addEventListener('submit',function(e){e.preventDefault();go();});
      $$('details',f).forEach(function(d){
        d.addEventListener('toggle',function(){
          if(d.open){$$('details',f).forEach(function(o){if(o!==d){o.open=false;}});}
        });
      });
      document.addEventListener('click',function(e){
        if(!f.contains(e.target)){$$('details',f).forEach(function(o){o.open=false;});}
      });
    });

    /* Vorteile auf der Produktseite in die Kaufbox setzen */
    var trust=$('[data-nkz-trust]'),bb=$('.buybox');
    if(trust&&bb){bb.appendChild(trust);}

    /* Live-Suche */
    var q=$('[data-nkz-q]'),box=$('[data-nkz-sugg]');
    if(q&&box){
      var tm,last='';
      var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      q.addEventListener('input',function(){
        clearTimeout(tm);
        var v=q.value.trim();
        if(v.length<2){box.hidden=true;return;}
        tm=setTimeout(function(){
          last=v;
          fetch(root+'search/suggest.json?q='+encodeURIComponent(v)+'&resources[type]=product&resources[limit]=6')
            .then(function(r){return r.json();})
            .then(function(d){
              if(v!==last){return;}
              var ps=(d.resources&&d.resources.results&&d.resources.results.products)||[];
              box.innerHTML='';
              if(!ps.length){
                var e=document.createElement('div');
                e.style.cssText='padding:12px 16px;font-size:14px;color:#5C5C5C';
                e.textContent='Keine Treffer für «'+v+'»';
                box.appendChild(e);
              }
              ps.forEach(function(p){
                var a=document.createElement('a');a.href=p.url;
                if(p.image){var im=document.createElement('img');im.src=p.image;im.alt='';im.loading='lazy';a.appendChild(im);}
                var t=document.createElement('span');
                var b=document.createElement('b');b.textContent=p.title;
                var s=document.createElement('small');s.textContent=money(p.price);
                t.appendChild(b);t.appendChild(s);a.appendChild(t);box.appendChild(a);
              });
              var all=document.createElement('a');all.className='all';
              all.href=q.form.getAttribute('action')+'?q='+encodeURIComponent(v)+'&type=product';
              all.textContent='Alle Ergebnisse anzeigen';
              box.appendChild(all);
              box.hidden=false;
            }).catch(function(){});
        },220);
      });
      document.addEventListener('click',function(e){if(!q.form.contains(e.target)){box.hidden=true;}});
      q.addEventListener('keydown',function(e){if(e.key==='Escape'){box.hidden=true;}});
    }
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
